import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js'
import {Line} from 'react-chartjs-2'
import {ChartData} from '../../redux/organizations'
import {Box} from '@mui/material'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
)

type Props = {
  data: ChartData
}

const ExamLineChart = ({data}: Props) => {
  const options: any = {
    responsive: true,
    interaction: {
      mode: 'index' as const,
      intersect: false,
    },
    stacked: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        type: 'linear' as const,
        display: true,
        position: 'left' as const,
        min: 0,
      },
    },
  }

  const labels = data?.labels

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Exam Results Reported',
        data: data?.reportedResults,
        borderColor: '#1377D4',
        backgroundColor: '#1377D4',
        yAxisID: 'y',
        pointRadius: 0,
      },
    ],
  }

  return (
    <Box position={'relative'}>
      <Line options={options} data={chartData} />
    </Box>
  )
}

export default ExamLineChart
